import React from 'react';
import PropTypes from 'prop-types';
import TableCell from '@mui/material/TableCell';
import Fade from '@mui/material/Fade';
import { UiIcon, UiTooltip, UiMenu } from 'ui-components';
import { Link } from 'react-router-dom';
import UiTableDeleteOptionModal from './ui-table-delete-option-modal/UiTableDeleteOptionModal';

const UiTableActions = (props) => {
  const { actions = {}, updateData, row, 'data-testid': dataTestId } = props;

  return (
    <TableCell align={'left'} sortDirection={false}>
      <div className='ui-table-actions' data-testid={`${dataTestId}`}>
        {actions?.inline
          ?.filter((x) => x.permission)
          ?.map((action) => {
            if (action?.render) return action?.render(action, updateData, row);
            if (action?.key === 'edit')
              return (
                <UiTooltip
                  key={action.key}
                  title={action?.tooltip}
                  enterDelay={500}
                  enterNextDelay={500}
                  placement='top'
                  TransitionComponent={Fade}
                >
                  <Link
                    to={action?.route?.replace(':id', row?.id)}
                    className='ui-table-actions-item'
                  >
                    <UiIcon icon={action?.iconSrc} color='#FFFFFF' />
                  </Link>
                </UiTooltip>
              );
            if (action?.key === 'delete')
              return (
                <UiTableDeleteOptionModal
                  selected={[row]}
                  action={action}
                  updateData={updateData}
                  record={row}
                  data-testid={action?.dataTestId}
                >
                  <UiTooltip
                    key={action.key}
                    title={action?.tooltip}
                    enterDelay={500}
                    enterNextDelay={500}
                    placement='top'
                    TransitionComponent={Fade}
                  >
                    <span
                      className='ui-table-actions-item'
                      data-testid={action?.dataTestId}
                    >
                      <UiIcon
                        icon={action?.iconSrc}
                        color={action?.iconColor ?? '#FFFFFF'}
                      />
                    </span>
                  </UiTooltip>
                </UiTableDeleteOptionModal>
              );
            return null;
          })}
        {/* نمایش اکشن های بیشتر  */}

        {actions?.more?.filter((x) => x.permission)?.length > 0 && (
          <UiMenu
            iconClassName='ui-table-actions-item'
            actionsList={actions?.more?.filter((x) => x.permission) || []}
            data={row}
            updateData={updateData}
            data-testid={`${dataTestId}-menu`}
          />
        )}
      </div>
    </TableCell>
  );
};

UiTableActions.propTypes = {
  actions: PropTypes.object,
  updateData: PropTypes.func,
  row: PropTypes.object,
  'data-testid': PropTypes.string,
};

export default UiTableActions;
